module.exports = __webpack_public_path__ + "static/media/icon4.28852a18.svg";